import { Outlet, useLoaderData } from "react-router-dom";
import { ExtendedFacility } from ".";
import { ConnectComponentsProvider } from "@stripe/react-connect-js";

export function AppFacilityFrame() {    
    const facility = useLoaderData() as ExtendedFacility;
    return <ConnectComponentsProvider connectInstance={facility.connectInstance}>
        <Outlet />
    </ConnectComponentsProvider>;
}